import React from "react";
import Select from "react-select";

const currencyOptions = [
  { value: "INR", label: "Rupees (INR)" },
  { value: "USD", label: "US Dollar (USD)" },
  { value: "EUR", label: "Euro (EUR)" },
];

const SelectWithSearch = ({ name, value, onChange }) => {
  const handleChange = (selectedOption) => {
    onChange({
      target: {
        name,
        value: selectedOption.value,
      },
    });
  };

  return (
    <Select
      className="f-14"
      options={currencyOptions}
      value={currencyOptions.find((option) => option.value === value)}
      onChange={handleChange}
      isSearchable
      placeholder="Select currency..."
    />
  );
};

export default SelectWithSearch;
